import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef, HostBinding } from '@angular/core';

import { languageService, languageSupport } from '@unpispas/upp-base';
import { TicketView } from '@unpispas/upp-data';

/** Shared guest ticket receipt preview (waiter / counter / ready overlays). */
@Component({
    selector: 'upp-guest-ticket-preview',
    templateUrl: './upp-preview.html',
    styleUrls: ['./upp-preview.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UppGuestTicketPreviewComponent extends languageSupport {
    @Input({ required: true }) ticket!: TicketView;
    @Input() color: 'warning' | 'success' = 'warning';
    @Output() Done = new EventEmitter<void>();

    @HostBinding('class.accent-success')
    get HostSuccess(): boolean {
        return this.color === 'success';
    }

    @HostBinding('class.accent-warning')
    get HostWarning(): boolean {
        return this.color !== 'success';
    }

    constructor(
        lang: languageService,
        change: ChangeDetectorRef,
    ) {
        super(lang, change);
    }

    OnDone(): void {
        this.Done.emit();
    }
}
